import { LoadingDots } from "PFComponents/loading_dots";
import React from "react";

export const WorkforceTableLoader = ({ isLoading, children }) => {
  if (isLoading) {
    return <LoadingDots circlesEnabled pageViewEnabled />;
  }

  return children;
};
